import { OpenApi } from 'coconut-open-api-js';

export default {
  api() {
    const { domain } = window.state;

    return window.location?.origin ? new OpenApi() : new OpenApi(domain);
  },
};
